import React, { useState, useContext, useEffect } from 'react';

import APICtx from '#api'
import { TplWSidebar as Tpl } from '#Template'
import Search, { SearchText } from '#Search'
import DataList from '#DataList'
import Dialog from '#Dialog'
import TypesEdit from './TypesEdit'
import Fab from '#Fab'

import { faPlus, faEdit, faTrash } from '@fortawesome/pro-regular-svg-icons'

const EditDialog = ({ edit, handleEditClose }) => (
	<Dialog
		handleClose={handleEditClose}
		open={edit!==null}
		title={edit?._id ? "Modifica tipologia" : "Crea nuova tipologia"}
		width="md"
	>
		{ edit!==null && <TypesEdit _id={edit._id} /> }
	</Dialog>
)

const tableDef = [
	{ label:"Descrizione", field:'label' },
]

export default function ContractsTypesList() {
	const api = useContext(APICtx)
	const [ ids, setIds ] = useState([])
	const [ searchString, setSearchString ] = useState('')
	const [ edit, setEdit ] = useState(null)
	
	const handleDelete = ({ _id, label }) => {
		api.dialogConfirm({
			text: 'Sei sicuro di voler cancellare la tipologia "' + label + '"?',
			onConfirm: () => api.call('contracts/types/del', { _id }).then(handleRefresh),
		})
	}
	const handleEditClose = async () => {
		await edit.handleRowRefresh()
		setEdit(null)
		await handleRefresh()
	}
	const handleRefresh = () =>
		api.call('contracts/types/list', { searchString }).then(setIds)
	useEffect(() => {
		handleRefresh()
	}, [ searchString ])

	const getRow = _id => api.call('contracts/types/get', { _id })
	const defBtns = [
		{ icon:faEdit, label:'Modifica', onClick:setEdit },
		{ icon:faTrash, label:'Elimina', onClick:handleDelete },
	]
	
	return (
		<Tpl title="Tipologie contratto">
			<EditDialog edit={edit} handleEditClose={handleEditClose} />
			<Search>
				<SearchText label="Cerca" name="src-text" onChange={setSearchString} />
			</Search>
			<DataList def={tableDef} rowActions={defBtns} ids={ids} getRow={getRow} pageSize={30} />
			<Fab label="Crea una tipologia" icon={faPlus} onClick={() => setEdit({})} />
		</Tpl>
	)
}
